import React from "react";
import PropTypes from "prop-types";
import { Route, Switch, Redirect } from "react-router-dom";
import Login from "../Login";
import routes from "../../config/routes";
import SignUp from "../SignUp";
import ForgotPassword from "../ForgotPassword";
import Products from "../Products";
import Company from "../Company";
import UnAuthSupport from "../Support/UnauthSupport.js";

const Component = ({ loggedIn }) =>
      loggedIn.length > 0 ? (
            <Redirect to="/" />
      ) : (
            <Switch>
                  <Route path={routes.products} component={Products} key={Date.now()}/>
                  <Route path={routes.company} component={Company} key={Date.now()}/>
                  <Route path={routes.support} component={UnAuthSupport} key={Date.now()}/>
                  <Route path={routes.login} component={Login} />
                  <Route path={routes.signup} component={SignUp} />
                  <Route path={routes.forgotPassword} component={ForgotPassword} />
            </Switch>
      );

Component.defaultProps = {
      loggedIn: []
};

Component.propTypes = {
      loggedIn: PropTypes.arrayOf(PropTypes.string)
};

export default Component;
